const GENERIC_ERROR_MESSAGES = {
  ACTIVITY_TYPE_NOT_SUPPORTED: 'ACTIVITY_TYPE_NOT_SUPPORTED',
  KYC_IDENTITY_REVIEW_EXPIRED: 'KYC_IDENTITY_REVIEW_EXPIRED',
  KYC_INVALID_QES: 'KYC_INVALID_QES',
  KYC_RESIDENCE_PERMIT_EXPIRED: 'KYC_RESIDENCE_PERMIT_EXPIRED',
  KYC_RESIDENCE_PERMIT_HOST_EXPIRED: 'KYC_RESIDENCE_PERMIT_HOST_EXPIRED',
  LEGAL_FORM_NOT_SUPPORTED: 'LEGAL_FORM_NOT_SUPPORTED',
  MISSING_BENEFICIARIES: 'MISSING_BENEFICIARIES',
};

const genericErrorMessagesLocales = {
  en: {
    ACTIVITY_TYPE_NOT_SUPPORTED: {
      description:
        "Sorry, we can't open your bank account. Unfortunately, Shine does not accept your company's activity type yet.",
      label: 'Activity type not supported',
    },
    KYC_IDENTITY_REVIEW_EXPIRED: {
      description:
        'We need additional documents to further check your application. Please add a valid proof of identity.',
      label: 'Identity verification',
    },
    KYC_INVALID_QES: {
      description:
        'An error occured. We invite you to confirm your identity information by electronic signature to finalize your application.',
      label: 'Invalid QES',
    },
    KYC_RESIDENCE_PERMIT_EXPIRED: {
      description:
        'Your residence permit has expired, could you please send us your récépissé by email to the following address domicile@shine.fr?',
      label: 'Residence permit expired/acknowledgement missing',
    },
    KYC_RESIDENCE_PERMIT_HOST_EXPIRED: {
      description:
        'Your hosts residence permit has expired, could you please send us of his récépissé by email to the following address domicile@shine.fr?',
      label: 'Host residence permit expired/acknowledgement missing',
    },
    LEGAL_FORM_NOT_SUPPORTED: {
      description:
        "Sorry, we can't open your bank account. Unfortunately, Shine does not accept your company type yet.",
      label: 'Legal form not supported',
    },
    MISSING_BENEFICIARIES: {
      description:
        'Some legal beneficiaires are missing. Please invite all directors and shareholders with more than 25% of the company shares.',
      label: 'Missing beneficiaires',
    },
  },
  fr: {
    ACTIVITY_TYPE_NOT_SUPPORTED: {
      description:
        "Nous sommes désolés, nous ne pouvons pas poursuivre l'ouverture de votre compte bancaire. Shine ne gère malheureusement pas encore le type d'activité de votre entreprise.",
      label: "Type d'activité non supporté",
    },
    KYC_IDENTITY_REVIEW_EXPIRED: {
      description:
        'Nous avons besoin de documents supplémentaires pour poursuivre la vérification de votre dossier. Veuillez ajouter une preuve d’identité en cours de validité.',
      label: 'Vérification d’identité',
    },
    KYC_INVALID_QES: {
      description:
        'Une erreur est survenue. Nous vous invitons à confirmer vos informations d’identité par signature électronique pour finaliser votre inscription.',
      label: 'QES Invalide',
    },
    KYC_RESIDENCE_PERMIT_EXPIRED: {
      description:
        'Votre titre de séjour est expiré, pourriez-vous nous transmettre son récépissé par email à l’adresse suivante : domicile@shine.fr ?',
      label: 'Titre de séjour expiré/récépissé manquant',
    },
    KYC_RESIDENCE_PERMIT_HOST_EXPIRED: {
      description:
        'Le titre de séjour de votre hébergeur est expiré, pourriez-vous nous transmettre son récépissé par email à l’adresse email suivante : domicile@shine.fr',
      label: 'Titre de séjour hébergeur expiré/récépissé manquant',
    },
    LEGAL_FORM_NOT_SUPPORTED: {
      description:
        "Nous sommes désolés, nous ne pouvons pas poursuivre l'ouverture de votre compte bancaire. Shine ne gère malheureusement pas encore votre type d'entreprise.",
      label: "Type d'entreprise non supporté",
    },
    MISSING_BENEFICIARIES: {
      description:
        'Certains bénéficiaires effectifs sont manquants. Merci d’inviter tous les dirigeants et actionnaires avec plus de 25% des parts de l’entreprise.',
      label: 'Bénéficiaires manquants',
    },
  },
};

module.exports = {
  GENERIC_ERROR_MESSAGES,
  genericErrorMessagesLocales,
};
